var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYandexPlusGradient = function SvgYandexPlusGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2263 0.225404C12.5073 0.0776246 11.7627 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22C17.0751 22 22 17.0751 22 11C22 10.8069 21.995 10.615 21.9852 10.4244H14.0106L12.4636 17.7763H9.53312L11.0801 10.4244H4.17311L4.75557 7.65191H11.6635L13.2263 0.225404Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4812 7.65191H14.594L15.9564 1.17727C18.5666 2.49692 20.5794 4.82632 21.4812 7.65191Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0.493274,
    y1: 2.59243,
    x2: 23.9627,
    y2: 7.44016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#48CCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.380208,
    stopColor: "#505ADD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#BE40C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBA82B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 0.493274,
    y1: 2.59243,
    x2: 23.9627,
    y2: 7.44016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#48CCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.380208,
    stopColor: "#505ADD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#BE40C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBA82B"
  })))));
};
export default SvgYandexPlusGradient;